module.exports = /[-\s]+(.)?/g


//////////////////
// WEBPACK FOOTER
// ./node_modules/to-style/src/stringUtils/hyphenRe.js
// module id = 797
// module chunks = 0